import { ThemeOptions } from '@mui/material';

export const MuiListItemText: ThemeOptions['components']['MuiListItemText'] = {
  styleOverrides: {
    root: () => ({
      margin: 0,
      color: 'inherit'
    }),
    secondary: ({ theme }) => ({
      color: theme.palette.text.secondary
    })
  }
};
